







import {Vue} from 'vue-property-decorator';
import Component from "vue-class-component";

@Component
export default class ConfirmBeforeLeaving extends Vue {

  beforeMount() {
    window.addEventListener("beforeunload", (e) => {
      this.preventLeaving(e);
    });
  }

  preventLeaving(event: BeforeUnloadEvent) {
    if (!this.$store.state.confirmBeforeLeaving.needToBlock) return;
    event.preventDefault();
    event.returnValue = ""; // Chrome requires returnValue to be set.
  }

}

